module.exports = __webpack_public_path__ + "media/images/banner-assets/zh-tw/banner2-5e5f594f45434838f1c92b423c153593.jpg";